import React from "react";
import { Link } from "react-router-dom";

const ErrorPage404 = (props) => {
  return (
    <>
      <div className="error-container">
        <div className="lottie-animation"></div>
        <div className="error-content">
          <h1>404</h1>
          <p>Oops! We couldn't find the page you were looking for.</p>
          <Link to="/" className="btn btn-primary">
            <i className="fa-solid fa-house me-2"></i>Go to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default ErrorPage404;
